/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DeepAnalysisControllerStreamQueryResponse, DeepAnalysisControllerStreamPathParams, DeepAnalysisControllerStream401, DeepAnalysisControllerStream403 } from "../../models/aiAgentV2Controller/DeepAnalysisControllerStream";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { deepAnalysisControllerStream } from "../../clients/ai-agent-v2Service/deepAnalysisControllerStream";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const deepAnalysisControllerStreamQueryKey = (sessionId: DeepAnalysisControllerStreamPathParams["sessionId"]) => [{
  url: '/api/v1/ai-agent-v2/deep-analysis/:sessionId/stream',
  params: {
    sessionId: sessionId
  }
}] as const;
export type DeepAnalysisControllerStreamQueryKey = ReturnType<typeof deepAnalysisControllerStreamQueryKey>;
export function deepAnalysisControllerStreamQueryOptions(sessionId: DeepAnalysisControllerStreamPathParams["sessionId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = deepAnalysisControllerStreamQueryKey(sessionId);
  return queryOptions<DeepAnalysisControllerStreamQueryResponse, ResponseErrorConfig<DeepAnalysisControllerStream401 | DeepAnalysisControllerStream403>, DeepAnalysisControllerStreamQueryResponse, typeof queryKey>({
    enabled: !!sessionId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return deepAnalysisControllerStream(sessionId, config);
    }
  });
}

/**
 * @summary Stream deep analysis events via SSE
 * {@link /api/v1/ai-agent-v2/deep-analysis/:sessionId/stream}
 */
export function useDeepAnalysisControllerStream<TData = DeepAnalysisControllerStreamQueryResponse, TQueryData = DeepAnalysisControllerStreamQueryResponse, TQueryKey extends QueryKey = DeepAnalysisControllerStreamQueryKey>(sessionId: DeepAnalysisControllerStreamPathParams["sessionId"], options: {
  query?: Partial<QueryObserverOptions<DeepAnalysisControllerStreamQueryResponse, ResponseErrorConfig<DeepAnalysisControllerStream401 | DeepAnalysisControllerStream403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? deepAnalysisControllerStreamQueryKey(sessionId);
  const query = useQuery({
    ...deepAnalysisControllerStreamQueryOptions(sessionId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DeepAnalysisControllerStream401 | DeepAnalysisControllerStream403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}